import service from '@/utils/request';

// @Tags partner
// @Summary 获取任务列表
// @Security ApiKeyAuth
// @Produce  application/json
// @Success 200 {string} string "{"success":true,"data":{},"msg":"返回成功"}"
// @Router /task/taskList [post]
export var taskList = function taskList(data) {
  return service({
    url: "/xcpGameData/task/taskList",
    method: 'post',
    data: data
  });
};

//任务列表下拉框
export var taskListAll = function taskListAll(data) {
  return service({
    url: "/xcpGameData/task/taskListAll",
    method: 'post',
    data: data
  });
};

//主线任务停留数据下拉框
export var taskDwellPoint = function taskDwellPoint(data) {
  return service({
    url: "/xcpGameData/task/taskDwellPoint",
    method: 'post',
    data: data
  });
};
export var mainTaskStayByCreateRoleTime = function mainTaskStayByCreateRoleTime(data) {
  return service({
    url: "/xcpGameData/task/taskDwellPointByCreateRoleTime",
    method: 'post',
    data: data
  });
};